import * as React from 'react';

import Button from 'components/ButtonDeprecated';
import TooltipTrigger from 'components/TooltipTrigger';

type Props = {
  button: React.ReactElement<typeof Button>;
};

export default function SchedulingDisabledTooltipWithButton(props: Props) {
  // Tooltip trigger does not work with disabled buttons so put the trigger on a containing div.
  return (
    <TooltipTrigger tooltip="Scheduling is currently only available to classes.">
      <div>{props.button}</div>
    </TooltipTrigger>
  );
}
